const data = {
	hostname: 'www.tyrepluscairns.com.au',
	id: 'tyrepluscairns',
	bookingLink: 'https://tyreplus.repairy.au/cairns',
	name: 'Tyre Plus Cairns',
	logo: '/images/TyreplusCairns/logo.webp',
	heroImage: '/images/TyreplusCairns/hero.jpg',
	theme: '#28a745',
	intro:
		'At our workshop, we pride ourselves on the quality of our repairs, the depth of our industry experience, and the extent of our customer service',
	googleAds: {
		metaTitle: 'Book service — Tyre Plus Cairns',
		metaDescription:
			'Book mechanical servicing, 4x4 accessories, suspension, tyre rotations and brake controllers online at Tyre Plus Cairns (Torque Tyres & Trailer Spares).',
		eyebrow: 'Tyre Plus Cairns',
		headline: 'Book online for mechanical service, 4x4 work or brake controllers',
		subheadline:
			'Mechanical servicing and logbook servicing for all makes and models, 4x4 accessories and suspension repairs, tyre rotations, and supply and fit of electric brake controllers including REDARC.',
		bullets: [
			'Mechanical servicing and repairs — qualified logbook servicing for cars, SUVs and 4x4s',
			'4x4 accessories and upgrades plus suspension repairs',
			'Tyre rotations; brake controllers from reputable brands including REDARC',
			'Book online — your slot is reserved instantly',
		],
		primaryCta: 'Book now',
	},
	services: [
		{
			id: 1,
			type: '4x4 Accessories & Upgrades',
			content:
				'Torque Tyres & Trailer Spares Cairns provides expert service, advice, repairs and installation of leading 4x4 accessories, upgrades and suspension products. We supply and fit aftermarket parts from the biggest names in the industry, with the goal of helping you to get the best performance from your 4x4.',
		},
		{
			id: 2,
			type: 'Suspension Repairs',
			content:
				'Your vehicle\'s suspension system is a key component to your on-road safety, and of course comfort. Made up of many components, including springs, shock absorbers, control arms, bushings, sway bars, ball joints and struts, it only takes an issue with one to compromise your safety.',
		},
		{
			id: 3,
			type: 'Tyre Rotations',
			content:
				'A tyre rotation is intended to spread out the tyre wear so that all four of your tyres wear out at the same time. Replacing tyres in sets results in optimal handling, performance and vehicle predictability. Book your vehicle in to see the team at Torque Tyres & Trailer Spares Cairns today!',
		},
		{
			id: 4,
			type: 'Mechanical Servicing & Repairs',
			content:
				'At Torque Tyres & Trailer Spares Cairns, our mechanics offer vehicle servicing and repairs for all makes and models. Our fully qualified log book servicing ensures your car, SUV or 4x4 is in safe hands. Torque Tyres & Trailer Spares Cairns can take care of all your service and maintenance requirements so that your vehicle runs the way it should.',
		},
		{
			id: 5,
			type: 'Brake Controllers',
			content:
				'We can supply and fit a range of electric brake controllers from reputable manufacturers, including the Australian-designed and made REDARC products.',
		},
	],
	otherServices: [
		'4x4 Accessories & Upgrades',
		'Suspension Repairs',
		'Tyre Rotations',
		'Mechanical Servicing & Repairs',
		'Brake Controllers',
	],
	reasons: [
		{
			id: 1,
			image: '/images/TyreplusCairns/experience.jpeg',
			title: 'Years of experience',
			desc:
				'Our team consist of skilled mechanics that take pride in delivering premium and comprehensive mechanical assistance using the latest technology.',
		},
		{
			id: 2,
			image: '/images/TyreplusCairns/trust.jpg',
			title: 'Service you can trust',
			desc:
				'We pride ourselves in delivering the highest quality of customer service and products to our valued customers.',
		},
		{
			id: 3,
			image: '/images/TyreplusCairns/above.webp',
			title: 'Above and beyond',
			desc:
				"If you're not happy with the service we provide, please let us know and we will do our best to achieve 100% customer satisfaction.",
		},
	],
	about: {
		image: '/images/TyreplusCairns/owner.jpeg',
		content: [
			<div key="sub-title">About Tyreplus Cairns</div>,
			<div key="title">Our Services</div>,
			<div key="content">
				At Torque Tyres &amp; Trailer Spares Cairns, our wide array of offerings
				includes everything from tyres and wheels to trailer spares/parts and
				4x4 accessories/upgrades.
				<br />
				We also offer a comprehensive suite of
				mechanical services tailored to meet the needs of those in Cairns who
				demand excellence for their vehicles.
				<br />
				<br />
				We ensure your vehicle&apos;s
				performance with suspension repairs, tyre rotations, fitting, wheel
				alignments, mechanical servicing and repairs and brake controllers.
			</div>,
		],
	},
	reviews: [
		{
			link:
				'https://www.google.com/maps/place/Tyreplus+Cairns/@-16.9407,145.7541251,17z/data=!3m1!4b1!4m6!3m5!1s0x697864198590161f:0xb442c6bfee0da322!8m2!3d-16.9407!4d145.7567!16s%2Fg%2F1tj91nzz?entry=ttu&g_ep=EgoyMDI2MDMxOC4xIKXMDSoASAFQAw%3D%3D',
			score: '',
			totalReview: '',
			type: 'Google',
		},
		{
			link: 'https://www.facebook.com/Torque.tyres.cairns/reviews',
			score: '',
			totalReview: '',
			type: 'Facebook',
		},
	],
	contacts: {
		googleMap: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3816.6875062058252!2d145.7541251!3d-16.9407!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x697864198590161f%3A0xb442c6bfee0da322!2sTyreplus%20Cairns!5e0!3m2!1sen!2ssg!4v1774399767987!5m2!1sen!2ssg',
		address: ['327 Little Spence Street,', 'Bungalow, QLD 4870.'],
		phone: '+61 7 4035 3550',
		email: 'cairns@tyreplus.com.au',
		opening: ['Monday - Thursday: 7am - 5pm', 'Friday: 8am - 5pm', 'Saturday: 8am - 12.00pm'],
	},
	isExtraLogos: true,
	extraLogos: [
		'/images/Others/michelin-logo.png',
		'/images/Others/BFGoodrich-logo-small-med.png',
		'/images/Others/pirelli-logo.png',
		'/images/Others/bridgestone-logo.png',
	],
	isExtraLogosFeatured: true,
};

export default data;
